<template>
    <div id="contact-details">
        <DCard
            :title="__('customers.contacts.titles.contact_info')"
            padding
        >
            <DFormRow :label="__('customers.contacts.contact_id')">
                {{ contact.id }}
            </DFormRow>
            <DFormRow :label="__('customers.common.title')">
                {{ contact.title }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.prefix_title')">
                {{ contact.prefix_title }}
            </DFormRow>
            <DFormRow :label="__('customers.common.firstname')">
                {{ contact.firstname }}
            </DFormRow>
            <DFormRow :label="__('customers.common.lastname')">
                {{ contact.lastname }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.postfix_title')">
                {{ contact.postfix_title }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.birthdate')">
                {{ setDateFormat(contact.birthdate) }}
            </DFormRow>
        </DCard>
        <DCard
            :title="__('customers.contacts.titles.contact_address')"
            padding
        >
            <DFormRow :label="__('customers.common.company')">
                {{ contact.company }}
            </DFormRow>
            <DFormRow :label="__('customers.common.address1')">
                {{ contact.address1 }}
            </DFormRow>
            <DFormRow :label="__('customers.common.address2')">
                {{ contact.address2 }}
            </DFormRow>
            <DFormRow :label="__('customers.common.postal_code')">
                {{ contact.postal_code }}
            </DFormRow>
            <DFormRow :label="__('customers.common.city')">
                {{ contact.city }}
            </DFormRow>
            <DFormRow :label="__('customers.common.region')">
                {{ contact.region }}
            </DFormRow>
            <DFormRow :label="__('customers.common.country')">
                {{ contact.country ? contact.country.name : '' }}
            </DFormRow>
        </DCard>
        <DCard
            :title="__('customers.contacts.titles.contact_communication')"
            padding
        >
            <DFormRow :label="__('customers.common.email')">
                {{ contact.email }}
            </DFormRow>
            <DFormRow :label="__('customers.common.phone')">
                {{ contact.phone }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.email_types')">
                <DTag
                    :color="contact.email_invoice ? 'success' : 'danger'"
                    :label="__('customers.contacts.invoice')"
                />
                <DTag
                    :color="contact.email_tech ? 'success' : 'danger'"
                    :label="__('customers.contacts.tech')"
                />
                <DTag
                    :color="contact.email_contract ? 'success' : 'danger'"
                    :label="__('customers.contacts.contracts')"
                />
                <DTag
                    :color="contact.email_newsletter ? 'success' : 'danger'"
                    :label="__('customers.contacts.newsletter')"
                />
            </DFormRow>
        </DCard>
        <DCard
            :title="__('customers.contacts.titles.contact_cp_and_support')"
            padding
        >
            <DFormRow :label="__('customers.contacts.support_pin')">
                {{ contact.support_pin }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.support_allowed')">
                {{ contact.support_allowed ? __('customers.common.yes') : __('customers.common.no') }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.allow_login')">
                {{ contact.allow_login ? __('customers.common.yes') : __('customers.common.no') }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.customer_cloudpit_account_id')">
                {{ contact.customer_cloudpit_account_id }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.function')">
                {{ contact.function }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.contact_categories')">
                {{ contactCategories }}
            </DFormRow>
            <DFormRow :label="__('customers.contacts.comment')">
                {{ contact.comment }}
            </DFormRow>
            <DFormRow :label="__('customers.common.telemarketing')">
                {{ contact.support_allowed ? __('customers.common.telemarketing_allowed') : __('customers.common.telemarketing_not_allowed') }}
            </DFormRow>
        </DCard>

        <DFabs>
            <s-s-o-fab
                :customer="customer"
                @open-modal="showCreateCloudpitCustomerModal = true"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
            <!--            <DFab-->
            <!--                v-if="userPermissions.includes('customer.edit')"-->
            <!--                icon="pencil"-->
            <!--                :label="__('messages.actions.edit')"-->
            <!--                @click="$inertia.get($route('customers.customers.contacts.edit', {customer: contact.customer_id, contact: contact.id}))"-->
            <!--            />-->
            <DFab
                v-if="userPermissions.includes('customer.edit')"
                icon="trash-can-outline"
                color="secondary"
                :label="__('messages.actions.delete')"
                @click="deleteContact()"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('customers.contacts.delete_confirm_modal.title')"
            :message="__('customers.contacts.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
        <CreateCloudPitCustomerModal
            :customer="customer"
            :show-modal="showCreateCloudpitCustomerModal"
            @close-modal="showCreateCloudpitCustomerModal = false"
        />
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'
import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'

export default {
    name: 'CustomerContactShow',
    components: { CreateCloudPitCustomerModal, SSOFab },
    layout: [App, CustomerBase],
    props: {
        customer: {
            type: Object,
            default: () => { return {} }
        },
        contact: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            deleteCallBack: () => { return {} },
            showCreateCloudpitCustomerModal: false
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        contactCategories () {
            // Convert the options object properties to a comma-separated string
            return this.contact.contact_categories ? Object.values(this.contact.contact_categories).join(', ') : ''
        }
    },
    methods: {
        deleteContact () {
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('customers.customers.contacts.destroy', {
                    customer: this.customer.id,
                    contact: this.contact.id
                }))
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        }
    }
}
</script>

<style lang="scss" scoped>
#contact-details {
    display: grid;
    grid-gap: 10px;
}
</style>
